(ns frontend.view.data-import.db
  (:require [frontend.db :as db]
            [frontend.state.current-session :as session]
            [reagent.core :as r]))

(defonce tenant session/tenant)

(defonce import-state (r/atom {}))

(defn get-template-options [state]
  @state)

(defn set-template-option [state k v]
  (swap! state assoc k v))

(defn get-template-option [state k]
  (get @state k))

(defn reset-on-close! [state]
  (reset! import-state {:import-step :import-step-intro})
  (reset! state {}))
